<template>
  <div
    id="users"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :title="title"
        :readonlyEliminar="true"
        permisosNuevoRegistro="crear_usuario_integracion_empresa"
        permisosEditar="editar_usuario_integracion_empresa"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    id: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      headers: [
        {
          text: 'Usuario',
          value: 'username',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Tipo de Usuario',
          value: 'usertype',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Estado',
          value: 'active',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
    name: '',
  }),
  mounted() {
    if (!this.can('cambiar_estado_usuario_integracion_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    if (!this.can('editar_usuario_integracion_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/users-integrations`;
    },
    title() {
      return 'Usuario de Integración';
    },
  },
};
</script>
